import { useEffect, useState } from 'react'
import { BOOKING_TYPE, BookingDto, ServiceCategoryDto } from '../../../../../definition'
import { asyncGetNewBookingOnDashboard } from '../../../../../services/booking.service'
import { toast } from 'react-toastify'
import { NavLink } from 'react-router-dom'
import moment from 'moment'
import { findParentCategory, findServiceCategory, renderDesignateAddress } from '../../../../../utils'
import { Tabs } from 'antd'
import { isArray } from 'lodash'

const limitBooking = 20

const items = [
  {
    key: 'Unassigned',
    label: 'Unassigned'
  },
  {
    key: 'Assigned',
    label: 'Assigned'
  }
]

const NewBookings = ({
  mainCategories,
  subCategories,
  childCategories
}: {
  mainCategories: ServiceCategoryDto[]
  subCategories: ServiceCategoryDto[]
  childCategories: ServiceCategoryDto[]
}) => {
  const [assignBookings, setAssignBookings] = useState<BookingDto[]>([])
  const [unAssignBookings, setUnassignBookings] = useState<BookingDto[]>([])
  const [bookings, setBookings] = useState<BookingDto[]>([])
  const [activeTab, setActiveTab] = useState('Unassigned')

  useEffect(() => {
    doLoadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const doLoadData = () => {
    Promise.all([doFetchAssignBookingData(), doFetchUnAssignBookingData()])
  }

  useEffect(() => {
    setBookings([])
    setTimeout(() => {
      if (activeTab === 'Unassigned' && unAssignBookings.length) {
        setBookings(unAssignBookings)
      } else if (activeTab === 'Assigned' && assignBookings.length) {
        setBookings(assignBookings)
      }
    }, 500)
  }, [activeTab, unAssignBookings, assignBookings])

  const doFetchAssignBookingData = async () => {
    try {
      const bookingRes = await asyncGetNewBookingOnDashboard({
        offset: 0,
        limit: limitBooking,
        assigned: true
      })
      setAssignBookings(bookingRes.data.items || [])
    } catch (error: any) {
      let errorMessage = error.response?.data?.error?.message || error.message
      toast.error(`${errorMessage}`)
    }
  }

  const doFetchUnAssignBookingData = async () => {
    try {
      const bookingRes = await asyncGetNewBookingOnDashboard({
        offset: 0,
        limit: limitBooking,
        assigned: false
      })
      const bookingsNews: BookingDto[] = [...bookingRes.data.items]
      const canLoadMoreBooking = (bookingsNews || []).length < bookingRes.data.count

      setUnassignBookings(bookingsNews || [])
      return {
        bookingsNews,
        canLoadMoreBooking
      }
    } catch (error: any) {
      let errorMessage = error.response?.data?.error?.message || error.message
      toast.error(`${errorMessage}`)
    }
  }

  if (!isArray(unAssignBookings) || !isArray(assignBookings)) {
    return <></>
  }

  return (
    <div className='new-bookings-list'>
      <div className='sticky'>
        <h6>New Bookings</h6>
        <div className='side-page-tabs small'>
          <Tabs defaultActiveKey={activeTab} items={items} onChange={(value) => setActiveTab(value)} />
        </div>
      </div>

      {bookings.map((booking) => {
        const findChildIdCategory = findServiceCategory(
          booking.bookedServices?.[0].service?.categoryId,
          childCategories
        )

        const findSubIdCategory = findParentCategory(findChildIdCategory, subCategories)
        const findmainIdCategory = findParentCategory(findSubIdCategory, mainCategories)

        if (booking.type === BOOKING_TYPE.ONE_TIME) {
          return (
            <NavLink
              className={'new-booking-item'}
              to={
                booking.type === BOOKING_TYPE.ONE_TIME
                  ? `/schedule/one-time-booking?bookingId=${booking.id}`
                  : `/schedule/contract-booking?bookingId=${booking.id}`
              }
              key={booking.code}
              id={booking.createdAt.toString()}
            >
              {booking.invoice?.paymentStatus === 'TO_PAY' && <div className='unpaid-label'>Unpaid</div>}
              <div style={{ fontWeight: 'bold' }}>{booking.code}</div>
              <div>{moment(booking?.tasks?.[0].timeSlotBeginAt).format('DD/MM/YYYY')}</div>
              <div>{moment(booking?.tasks?.[0].timeSlotBeginAt).format('HH:mm')}</div>
              {booking?.tasks?.[0] && <div>{renderDesignateAddress(booking?.tasks?.[0])}</div>}
              {booking?.tasks?.[0].postalCode && <div>{booking?.tasks?.[0].postalCode}</div>}
              <div>{findmainIdCategory?.name}</div>
              <div>
                {booking.bookedServices?.map((bookedServices) => (
                  <div key={bookedServices.service?.id}>
                    <span className='booking-card-row-item'>{bookedServices.service?.name}</span>
                  </div>
                ))}
              </div>
            </NavLink>
          )
        } else {
          return booking.tasks
            ?.sort((a, b) => (a.taskIndex > b.taskIndex ? 1 : -1))
            .map((task) => {
              return (
                <NavLink
                  className={'new-booking-item'}
                  to={
                    booking.type === BOOKING_TYPE.ONE_TIME
                      ? `/schedule/one-time-booking?bookingId=${booking.id}`
                      : `/schedule/contract-booking?bookingId=${booking.id}`
                  }
                  key={booking.code}
                  id={`${booking.createdAt}-${task.taskIndex}`}
                >
                  {booking.invoice?.paymentStatus === 'TO_PAY' && <div className='unpaid-label'>Unpaid</div>}
                  <div style={{ fontWeight: 'bold' }}>
                    {booking.code}-{task.taskIndex}
                  </div>
                  <div>{task.timeSlotBeginAt ? moment(task.timeSlotBeginAt).format('DD/MM/YYYY') : '-'}</div>
                  <div>{task.timeSlotBeginAt ? moment(task.timeSlotBeginAt).format('HH:mm') : '-'}</div>
                  {booking?.tasks?.[0] && <div>{renderDesignateAddress(booking?.tasks?.[0])}</div>}
                  {booking?.tasks?.[0].postalCode && <div>{booking?.tasks?.[0].postalCode}</div>}
                  <div>{findmainIdCategory?.name}</div>
                  <div>
                    {booking.bookedServices?.map((bookedServices) => (
                      <div key={bookedServices.service?.id}>
                        <span className='booking-card-row-item'>{bookedServices.service?.name}</span>
                      </div>
                    ))}
                  </div>
                </NavLink>
              )
            })
        }
      })}
    </div>
  )
}

export default NewBookings
